/**
 * A Stimulus controller that dispatches bootstrap-toggle JS lib (http://www.bootstraptoggle.com) events with Stimulus
 *
 * @module BootstrapToggleController
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['element'];

  connect() {
    $(this.element).on('change.bootstrap-toggle', () => {
      this.dispatch('toggle');
    });
  }

  disconnect() {
    $(this.element).off('change.bootstrap-toggle');
  }
}
